import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from '../../services/user.service';
import { User } from '../../classes/user';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { JwtHelper } from 'angular2-jwt';
import { Title } from '@angular/platform-browser';
import { NgForm } from '@angular/forms';
import { ModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss']
})
export class LoginPageComponent implements OnInit {
  authPlatform: boolean = false;
  authOnboarding: boolean = false;
  sub: any;
  registerSuccess: number;
  msgs: any[] = [];
  user = new User();
  showPassword = false;
  jwtHelper: JwtHelper = new JwtHelper();
  msg: string;
  onboardingUser: any = <any>{};
  orgs: any[];
  loggingIn: boolean = false;
  mail: string;
  params: any;
  emailFocus: boolean = false;
  passwordFocus: boolean = false;
  submittingEmail: boolean = false;
  resetEmailFocus: boolean = false;
  resetError: string = '';
  resetData: any = <any>{ resetEmail: '' };
  @ViewChild('vmodal') vmodal: ModalComponent;
  @ViewChild('emailModal') emailModal: ModalComponent;

  constructor(
    private UserService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private titleService: Title
  ) { }

  ngOnInit() {
    this.titleService.setTitle('Already a client? Sign in to your Rise Start account | Rise People');
    this.sub = this.route.params.subscribe(params => {
      this.msgs = [];
      this.params = params;
      this.registerSuccess = +params['registerSuccess'];
      this.mail = params['email'];
      console.log(this.mail)
      if (this.registerSuccess == 1 && this.mail) {
        this.vmodal.open();
      }
      else if (this.registerSuccess == 2) {
        this.msgs.push({ text: 'Email confirmation is successful.', class: 'alert-success' });
      }
      else if (this.registerSuccess == 3) {
        this.msgs.push({ text: 'Email has already been verified.', class: 'alert-danger' });
      }
      else if (this.registerSuccess == 4) {
        this.msgs.push({ text: 'Password reset is successful.', class: 'alert-success' });
      }
      else if (this.registerSuccess == 5) {
        this.msgs.push({ text: 'If your email address exists in our database, you will receive a password recovery link at your email address in a few minutes. Click link inside to start resetting your password', class: 'alert-success' });
      }
      else if (this.registerSuccess == 6) {
        this.msgs.push({ text: 'Email verification token is invalid.', class: 'alert-danger' });
      }
      else if (this.registerSuccess == 7) {
        this.msgs.push({ text: 'Sorry, for security reasons this email verification has expired. To verify your email, please email us at <a href="mailto:smallbusiness@risepeople.com">smallbusiness@risepeople.com</a> and we\'ll send you a new email verification.', class: 'alert-danger' });
      }
    })

    if (localStorage.onboardingToken) {
      this.UserService.getUserInfo()
        .subscribe(usr => {
          let org = JSON.parse(usr.user).organizations[0];
          this.router.navigate(['/onboarding/dashboard/multiple', org.id]);
        });
    }
  }

  login(loginForm: NgForm) {
    this.msgs = [];
    this.loggingIn = true;
    if (loginForm.invalid) {
      return;
    }

    let data = { user: this.user };
    data.user.email = data.user.email.toLowerCase();
    this.UserService
      .onboardingLogin(data)
      .subscribe(
      onboardingRes => {
        console.log(onboardingRes.access_token);
        localStorage.onboardingToken = onboardingRes.access_token;
        this.authOnboarding = true;
      },
      err => {
        this.msgs.push({ text: JSON.parse(JSON.parse(err._body).flash)[0][1], class: 'alert-danger' });
        this.authOnboarding = false;
      },
      () => {
        this.getUserInfo();
      }
      );
  }

  getUserInfo() {
    this.UserService
      .getUserInfo()
      .subscribe(
      onboardingUser => {
        localStorage.onboardingUser = JSON.stringify(onboardingUser);
        this.onboardingUser = JSON.parse(onboardingUser.user);
        this.orgs = this.onboardingUser.organizations;
      },
      err => {
        this.msgs.push({ text: JSON.parse(JSON.parse(err._body).flash)[0][1], class: 'alert-danger' });
        this.authOnboarding = false;
      },
      () => {
        this.redirectToTop();
      }
      );
  }

  redirectToTop() {
    if (this.authPlatform || this.authOnboarding) {
      this.loggingIn = false;
      if (this.onboardingUser.admin) {
        this.router.navigate(['/admin/review']);
      }
      else {
        console.log(this.orgs);
        if (this.orgs.length == 1 && !this.orgs[0].completed && !this.orgs[0].archived) {
          let orgId: number = this.orgs[0].id;
          this.router.navigate(['/onboarding/dashboard/multiple', orgId]);
        }
        else if (this.orgs.length == 0) {
          this.UserService.saveSignUpUser(this.onboardingUser);
          this.router.navigate(['/onboarding/companyinfo', 1]);
        }
        else {
          this.msgs.push({ text: 'You have already finished the onboarding process.', class: 'alert-danger' });
        }
      }
    }
  }

  openEmailModal() {
    this.emailModal.open();
  }

  getResetPasswordEmail(emailForm: NgForm) {
    if (emailForm.invalid) {
      return;
    }
    this.UserService.getPasswordResetEmail(this.resetData.resetEmail)
      .subscribe(res => {
        this.emailModal.close();
        this.router.navigate(['/', 5]);
      }, err => {
        this.resetError = JSON.parse(JSON.parse(err._body).flash)[0][1];
      })

  }

  closeEmailModal(e: any) {
    console.log(e)
    if (e.target.className != "modal-body") {
      this.emailModal.close();
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/login-page/login-page.component.ts